// extracted by mini-css-extract-plugin
export var tile_content = "collectionTileStyles-module--tile_content--a791a";
export var tile_content_button = "collectionTileStyles-module--tile_content_button--81ad3";
export var tile_content_image = "collectionTileStyles-module--tile_content_image--17c06";
export var tile_content_link = "collectionTileStyles-module--tile_content_link--8d17a";
export var tiles_container = "collectionTileStyles-module--tiles_container--440e9";
export var tiles_container_padding = "collectionTileStyles-module--tiles_container_padding--8f127";
export var tiles_container_tag = "collectionTileStyles-module--tiles_container_tag--a950d";